export default __webpack_public_path__ + "static/media/img-mobile.fa91f2b3.jpg";